module.exports = __webpack_public_path__ + "static/media/user_mobile.af9a6e87.svg";